/**
 * Sabit adımlı güncelleme + değişken kare hızı.
 * Fizik/oynanış dt'den bağımsız davranır (yavaş cihazda oyun "hızlanmaz"),
 * render ise mevcut FPS'te çalışır. Sekme arka plana alındığında birikmiş
 * zaman sınırlandırılır ki geri dönüşte oyun ileri sarmasın.
 */
export interface LoopCallbacks {
  /** Sabit adımlı mantık. */
  fixed: (step: number) => void;
  /** Kare başına render/interpolasyon. */
  render: (dt: number, alpha: number) => void;
}

export class Loop {
  private readonly step: number;
  private accumulator = 0;
  private last = 0;
  private rafId = 0;
  private running = false;
  private frameSkipBudget = 5;

  /** Ölçülen anlık FPS. */
  fps = 0;
  private fpsAccum = 0;
  private fpsFrames = 0;

  constructor(private cbs: LoopCallbacks, hz = 60) {
    this.step = 1 / hz;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.last = performance.now();
    this.accumulator = 0;
    this.rafId = requestAnimationFrame(this.tick);
  }

  stop(): void {
    this.running = false;
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = 0;
  }

  private tick = (now: number): void => {
    if (!this.running) return;
    this.rafId = requestAnimationFrame(this.tick);

    let dt = (now - this.last) / 1000;
    this.last = now;
    // Uzun donmalarda (sekme değişimi, GC) zamanı kırp.
    if (!Number.isFinite(dt) || dt < 0) dt = 0;
    if (dt > 0.25) dt = 0.25;

    this.fpsAccum += dt;
    this.fpsFrames++;
    if (this.fpsAccum >= 0.5) {
      this.fps = this.fpsFrames / this.fpsAccum;
      this.fpsAccum = 0;
      this.fpsFrames = 0;
    }

    this.accumulator += dt;
    let steps = 0;
    while (this.accumulator >= this.step && steps < this.frameSkipBudget) {
      this.cbs.fixed(this.step);
      this.accumulator -= this.step;
      steps++;
    }
    // Bütçe aştıysa kalanı at: spiral of death engellenir.
    if (steps >= this.frameSkipBudget) this.accumulator = 0;

    this.cbs.render(dt, this.accumulator / this.step);
  };
}
